import { PISignalRMessage, PISignalRMessageData } from '../../core-services';

export type SignalRStatusTypes =
    | 'ToBeProcessed'
    | 'Processing'
    | 'ProcessingFailed'
    | 'Complete'
    | 'CompleteWithErrors'
    | 'UploadFailed'
    | undefined;

export class PlatformOrgUploadSignalRNotification
    implements PISignalRMessage<PlatformOrgUploadSignalRPayload>
{
    data: PlatformOrgUploadSignalRPayload =
        new PlatformOrgUploadSignalRPayload();
    eventTarget = 'PlatformOrgUploadStatusUpdated';
}

export class PlatformOrgUploadSignalRPayload implements PISignalRMessageData {
    CompanyFileUploadId: string;
    Status: SignalRStatusTypes;
    WorkflowId: string;
    TotalCSVRows: number;
    CSVRowsProcessed: number;
    TotalToArchive: number;
    ArchiveProcessed: number;

    constructor() {
        this.CompanyFileUploadId = '';
        this.Status = undefined;
        this.WorkflowId = '';
        this.TotalCSVRows = null;
        this.CSVRowsProcessed = null;
        this.TotalToArchive = null;
        this.ArchiveProcessed = null;
    }
}
